import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IDataContext } from '../list/component.interface';
import { InputControlBase } from '../forms/input-control.base';

/** @deprecated Use `astral-toggle` in new or Astralized templates. */
@Component({
    selector: 'app-toogle',
    templateUrl: './toogle.component.html',
    styleUrls: ['./toogle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToogleComponent extends InputControlBase<boolean> implements IDataContext {
  @Input() showCaption: boolean = true;
  constructor() {
    super();
  }

  @Input() labelPosition: 'top' | 'right' = 'top';
  dataContext: boolean;

  get lockClass(): string {
    if (this.control && this.control.isReadonly) return 'locked';
    return undefined;
  }

  onClick(event: any) {
    if (this.control && this.control.isReadonly) return false;
  }

  onToggleChange(event: Event) {
    const value = (event.target as HTMLInputElement).checked;
    this.valueChange.emit({
      formSnapshot: null,
      newValue: value,
      previousValue: !value,
    });
  }

  get isDisabled(): boolean {
    return this.control.disabled;
  }
}
